import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TTSlotsCloneForm.html?raw';
import "../../../moreCore/UI/GenericDialog/GenericDialog";

import { TiEntities } from "../TiTypes";
import _uiFrameMixin from '../../../moreCore/UI/Container/uiFrame';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import "../../../moreCore/UI/NumberInput/NumberInput";
import DateTimeInput from '../../../moreCore/UI/DateTimeInput/DateTimeInput';
import "../../../moreCore/UI/DateTimeInput/DateTimeInput";


interface dataResponse {
    resourcepickerData: ResourcePicker.ResourcePickerConfiguration,
    slots: Array<TiEntities.TimeTableSlotEntity>,
    divisions: Array<TiEntities.DivisionEntity>,
    allowedStatusIDs: Array<string>
}

interface ResultData {
    newStartDate: Date,
    newStart: string,
    newEndDate: Date,
    newEnd: string,
    bufferTimeMinutes: Number //Number? number? Number? number?
}
class TTSlotsCloneForm extends compose(_uiFrameMixin) {

    templateString: any = template;


    private inputStart: MdsLax<InstanceType<typeof DateTimeInput>>;
    private inputEnd: MdsLax<InstanceType<typeof DateTimeInput>>;
    private inputBufferTime: MdsLax<InstanceType<typeof NumberInput>>;
    private inputPickupDate: MdsLax<InstanceType<typeof DateTimeInput>>;

    private callback: Function;


    setup(baseEntity: TiEntities.TimeslotEntity, resultCallback: (data: FormData) => void) {
        this.inputStart.setValue(baseEntity.date_start, true);
        this.inputEnd.setValue(baseEntity.date_end, true);
        this.inputBufferTime.setValue(baseEntity.buffer_time, true);
        this.inputPickupDate.setValue(baseEntity.pickup_date, true);

        this.createDefaultButton("ok", lang.hitch(this, this._onConfirm), false);

        this.callback = resultCallback;

        this._serializeData();
    }

    private _onConfirm() {
        if (this.callback) {
            this.callback(this.getResult());
        }

        this.close();
    }


    private currentFormData: ResultData;
    private serializeData() {
        if (this._serializeDateHandle) clearTimeout(this._serializeDateHandle);

        this._serializeDateHandle = setTimeout(lang.hitch(this, this._serializeData), 50);
    }

    private _serializeDateHandle: any = null;
    private _serializeData() {
        let currentData: ResultData = {
            newStartDate: this.inputStart.getValue()?.date,
            newEndDate: this.inputEnd.getValue()?.date,
            newStart: this.inputStart.getValueAsLocalISOstring(),
            newEnd: this.inputEnd.getValueAsLocalISOstring(),
            bufferTimeMinutes: this.inputBufferTime.getValue()
        };

        // Pflichtangaben?

        if (currentData.newStart && currentData.newEnd && (currentData.bufferTimeMinutes as number) >= 0) {
            this.currentFormData = currentData;
        } else {
            this.currentFormData = null;
        }


        this.enableButton("ok", !!this.currentFormData);
    }

    getResult(): ResultData {
        return this.currentFormData;
    }

    private _onChange_DateStart() {

        if (this.currentFormData) {

            let currentStart = this.currentFormData.newStartDate ? new Date(this.currentFormData.newStartDate.valueOf()) : null;
            let currentEnd = this.currentFormData.newEndDate ? new Date(this.currentFormData.newEndDate.valueOf()) : null;
            let newStart = this.inputStart.getValue()?.date;



            if (currentStart && currentEnd && newStart) {
                let diff = newStart.valueOf() - currentStart.valueOf();
                if (diff != 0) {
                    let newEnd = new Date(currentEnd.getTime() + diff);


                    this.inputEnd.setValue(newEnd);
                    return;
                }
            }
        }

        this.serializeData();
    }

    private _onChange_DateEnd() {
        this._onChange_BufferTime();
    }

    private _onChange_BufferTime() {

        let end = this.inputEnd.getValue()?.date;
        let bufferTime = this.inputBufferTime.getValue();


        if (end && bufferTime >= 0) {

            let pickupDate: Date = new Date(end.valueOf());
            pickupDate.setTime(end.valueOf() + bufferTime * 60 * 1000);
            this.inputPickupDate.setValue(pickupDate);

        } else {
            this.inputPickupDate.setValue(null);
        }
        this.serializeData();

    }




    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(TTSlotsCloneForm);
